import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { RulesConstants } from '../store/rules.constants'
import { IRulesState, RulesErrors } from '../store/rules.types'
import { getRulesSelector } from '../selectors'
import { mapRuleErrors } from '../../../utilities/runRulesValidation.util'
import { setIsPCRClosing } from '../../home/store/home.actions'
import { resetPCRState } from '../../home/saga/resetPCR.saga'

export function* saveRuleErrors() {
  yield put(setIsPCRClosing(true))
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const rules: IRulesState = yield select(getRulesSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    const flatErrArr: RulesErrors = Object.values(rules.errors).flat()

    for (let i = flatErrArr.length - 1; i >= 0; i--) {
      if (flatErrArr[i].reduxStateOnlyFlag) {
        flatErrArr.splice(i, 1)
      }
    }
    rules.errors = mapRuleErrors(flatErrArr)

    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc, rules }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveRuleErrors() error: ${e}`))
    }
  }
  yield call(resetPCRState)
  yield put(setIsPCRClosing(false))
}
export function* saveRuleErrorsSaga() {
  yield takeLatest([RulesConstants.SAVE_RULE_ERRORS], performWithMutexHOG, saveRuleErrors)
}
